module.exports = __webpack_public_path__ + "img/Koda_Beta.c7acf50.svg";